var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEraser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 470,
    viewBox: "0 0 562 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M550.065 445.539H230.624L274.854 405.702L461.604 238.666C472.837 228.183 479.858 214.205 480.56 198.829C481.262 183.454 476.348 168.777 465.817 156.896L342.253 19.2138C321.19 -4.54861 283.981 -6.64528 260.111 15.0204L19.3011 230.978C-4.56927 252.644 -6.67547 288.987 15.0886 312.749L135.844 446.238H19.3011C12.9824 446.238 7.36589 451.13 7.36589 458.119C7.36589 465.108 12.2804 470 19.3011 470H550.065C556.383 470 562 465.108 562 458.119C562 451.13 557.085 445.539 550.065 445.539ZM275.556 32.4927C281.875 26.9016 290.299 23.4071 298.724 23.4071C308.553 23.4071 317.68 27.6005 324.701 34.5894L448.967 172.271C455.286 179.26 458.094 187.647 458.094 197.432C457.392 206.517 453.881 214.904 446.861 221.194L268.535 380.542L97.9327 191.84L275.556 32.4927ZM23.5135 271.514C24.2155 262.429 27.7259 254.042 34.7466 247.752L79.6789 207.216L250.282 395.917L205.349 436.453C191.308 449.033 168.842 448.334 156.204 433.658L32.6404 296.674C26.3217 289.686 22.8114 281.299 23.5135 271.514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraser);
export default __webpack_public_path__ + "static/media/Eraser.19bfbc32b467b8ae631bb3249bf6ce06.svg";
export { ForwardRef as ReactComponent };